/**
 * A deploy replaces the hashed chunks, so a page that runs the old build cannot load a panel or a
 * page it has not loaded yet. It loads the new build, as useUpdateOnOpen does. A panel that holds
 * unsaved work keeps the page, and the panel that failed shows its error.
 */

import { versionWatch } from '@/api/version';
import type { VersionWatch } from '@/types/contract';

import { hasUnsavedWork } from './panelCloseGuards';

export function reloadOnStaleChunk(watch: VersionWatch = versionWatch): void {
    window.addEventListener('vite:preloadError', (): void => {
        watch.check().then((isOutdated): void => {
            if (isOutdated && !hasUnsavedWork()) {
                window.location.reload();
            }
        });
    });
}
